import React from 'react';
import { VerifiedRounded } from '@mui/icons-material';
import { Colors } from 'library';
import { Card, Row, Stack, Text } from 'library/ui';
import { formatNumericMonthDayYear } from 'shared/Dates';
import { CoveredShift } from './coveredShiftsApi';

export function CoveredShiftsCallout({ coveredShifts }: { coveredShifts: CoveredShift[] }) {
    if (coveredShifts.length === 0) return null;

    const centerNames = new Set(coveredShifts.map((shift) => shift.business_location_name));
    const showCenterName = centerNames.size > 1;

    return (
        <Stack gap="sm">
            {coveredShifts.map((shift) => (
                <Card key={shift.id} tone="success" padding="sm">
                    <Row gap="sm" align="start">
                        <VerifiedRounded sx={{ fontSize: 20, color: Colors.success }} />
                        <Stack gap="none">
                            <Text weight="bold">
                                {shift.subs_remaining}{' '}
                                {shift.subs_remaining === 1 ? 'substitute is' : 'substitutes are'} covered by{' '}
                                {shift.sub_pool_name} on {formatNumericMonthDayYear(shift.shift_day)}
                                {showCenterName && shift.business_location_name
                                    ? ` at ${shift.business_location_name}`
                                    : ''}
                            </Text>
                            {shift.description && (
                                <Text size="sm" tone="secondary">
                                    {shift.description}
                                </Text>
                            )}
                        </Stack>
                    </Row>
                </Card>
            ))}
        </Stack>
    );
}
